import {Component, OnDestroy} from '@angular/core';
import {TranslatePipe, TranslateService} from '@ngx-translate/core';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {MatFormField, MatOption, MatSelect, MatSelectModule} from '@angular/material/select';

import {TranslatorService} from '../../services/translator.service';
import {LanguageEnum} from '../../enums/language.enum';
import {MatFormFieldModule} from '@angular/material/form-field';
import {ApplicationInfoService} from '../../services/application-info.service';
import {ApplicationInfoModel} from '../../models/application-info.model';
import {Subject, takeUntil} from 'rxjs';
import {CollaboratorHelperService} from '../../services/collaborator-helper.service';

@Component({
  selector: 'app-settings',
  imports: [
    TranslatePipe,
    MatDialogContent,
    MatDialogTitle,
    MatDialogActions,
    MatButton,
    MatDialogClose,
    MatSelect,
    MatOption,
    MatFormField,
    MatFormFieldModule,
    MatSelectModule
  ],
  templateUrl: './settings.component.html',
  styleUrl: './settings.component.scss'
})
export class SettingsComponent implements OnDestroy {
  private readonly destroy$ = new Subject<void>();
  readonly availableLanguages = Object.keys(LanguageEnum).map(key => ({
    label: key,
    code: LanguageEnum[key as keyof typeof LanguageEnum]
  }));
  applicationInfo: ApplicationInfoModel | null = null;
  selectedLanguage: { code: LanguageEnum; label: string } = this.availableLanguages[0];


  constructor(private readonly translatorService: TranslatorService,
              private readonly translateService: TranslateService,
              collaboratorHelperService: CollaboratorHelperService,
              applicationInfoService: ApplicationInfoService) {
    this.selectedLanguage = this.availableLanguages.find(lang => lang.code === this.translateService.currentLang) || this.availableLanguages[0];
    if (!collaboratorHelperService.isCollaboratorView) {
      applicationInfoService.getApplicationInfo().pipe(
        takeUntil(this.destroy$) // Ensure to unsubscribe when the component is destroyed
      ).subscribe(applicationInfo => {
        this.applicationInfo = applicationInfo;
      });
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }


  changeLanguage(language: { code: LanguageEnum; label: string }) {
    this.translatorService.switchLanguage(language.code);
  }
}
